function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { MDCTextInput } from "../../../jsx/components/mdc-components";
class Location extends React.Component {
  constructor(_props) {
    super(_props);
    _defineProperty(this, "onCityChange", event => {
      let props = this.props;
      let location = props.location;
      let index = location.index;
      var target = event.target;
      var value = target.value;
      props.onChange('city', value, index);
    });
    _defineProperty(this, "onStateChange", event => {
      let props = this.props;
      let location = props.location;
      let index = location.index;
      var target = event.target;
      var value = target.value;
      props.onChange('state', value, index);
    });
    _defineProperty(this, "onCountryChange", event => {
      let props = this.props;
      let location = props.location;
      let index = location.index;
      var target = event.target;
      var value = target.value;
      props.onChange('country', value, index);
    });
    _defineProperty(this, "onRemove", event => {
      let props = this.props;
      let location = props.location;
      let index = location.index;
      this.props.onRemove(index);
    });
  }
  componentDidMount() {}
  render() {
    var props = this.props;
    var location = props.location;
    return /*#__PURE__*/React.createElement("div", {
      className: "research-location-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "inputs"
    }, /*#__PURE__*/React.createElement(MDCTextInput, {
      label: "City",
      value: location.city,
      onChange: this.onCityChange
    }), /*#__PURE__*/React.createElement(MDCTextInput, {
      label: "State",
      value: location.state,
      onChange: this.onStateChange
    }), /*#__PURE__*/React.createElement(MDCTextInput, {
      label: "Country",
      value: location.country,
      onChange: this.onCountryChange
    })), /*#__PURE__*/React.createElement("div", {
      className: "action"
    }, location.index > 0 && /*#__PURE__*/React.createElement("span", {
      className: "material-icons grey-icon-pointer",
      onClick: this.onRemove
    }, "remove")));
  }
}
export default class Locations extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  get nodes() {
    let props = this.props;
    return props.locations.map(item => {
      return /*#__PURE__*/React.createElement(Location, {
        key: item.index,
        location: item,
        onChange: props.onChange,
        onRemove: props.onRemove
      });
    });
  }
  render() {
    let nodes = this.nodes;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "research-locations"
    }, nodes));
  }
}